import {
  PAYMENT_STATUS_LABELS,
  REQUEST_STATUS_LABELS,
  visiblePaymentStatus,
  type PaymentStatus,
  type RequestStatus,
} from '@i9portal/shared';
import { PAYMENT_STATUS_TONE, STATUS_TONE } from '@i9portal/ui';

function cssVar(token: string): string {
  return `var(--color-${token.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`)})`;
}

function toneStyle(tone: { fg: string; bg: string } | undefined) {
  return tone ? { color: cssVar(tone.fg), backgroundColor: cssVar(tone.bg) } : undefined;
}

interface StatusBadgeProps {
  status: RequestStatus;
  /** Quando informado e a solicitação estiver aprovada, exibe também o selo de pagamento. */
  paymentStatus?: PaymentStatus;
  className?: string;
}

/** Selo de status com as cores definidas em STATUS_TONE (@i9portal/ui). */
export function StatusBadge({ status, paymentStatus, className }: StatusBadgeProps) {
  const label = REQUEST_STATUS_LABELS[status] ?? status;
  const payment = paymentStatus ? visiblePaymentStatus(status, paymentStatus) : null;
  return (
    <>
      <span
        className={`badge badge--status${className ? ` ${className}` : ''}`}
        data-status={status}
        style={toneStyle(STATUS_TONE[status])}
      >
        {label}
      </span>
      {payment && <PaymentStatusBadge paymentStatus={payment} />}
    </>
  );
}

/** Selo do status de pagamento (Não pago / Pago). */
export function PaymentStatusBadge({ paymentStatus }: { paymentStatus: PaymentStatus }) {
  return (
    <span
      className="badge badge--status"
      data-payment-status={paymentStatus}
      style={toneStyle(PAYMENT_STATUS_TONE[paymentStatus])}
    >
      {PAYMENT_STATUS_LABELS[paymentStatus]}
    </span>
  );
}
